/** 优惠码。key 是码,value 是折扣比例 */
const COUPONS: Record<string, { rate: number }> = {
  WELCOME10: { rate: 0.1 },
  VIP20: { rate: 0.2 },
};

/** 按优惠码算出要减多少钱(分)。码不存在返回 0,由页面提示 */
export function applyCoupon(code: string, subtotal: number): number {
  const coupon = COUPONS[code.trim().toUpperCase()];
  if (!coupon) return 0;
  return Math.round(subtotal * coupon.rate);
}
